export const MessageServerError = 'An error occurred. Please try again later or contact Support';
export const MessageRefreshPage = 'Data has been changed. Please refresh the page to see the latest changes';